module.exports = __webpack_public_path__ + "img/footer_pic_mb.d5c2d64c.jpg";